import { parseAgentMessage } from "@/utils";
import type {
  ChatPreset,
  ChatStrategies,
  FunctionCall,
  FunctionResponse,
  ToolRenderKind,
} from "@/types";

const BASE_MARKDOWN_RESOURCE_LINK_SCHEMES: readonly string[] = [];

export const baseToolKindResolver = (): ToolRenderKind => "default";

/** SDK 基础策略：不带任何企业协议偏好的最小行为集合。 */
export const baseChatStrategies: Required<
  Pick<
    ChatStrategies,
    | "resolveToolKind"
    | "createFunctionResponse"
    | "parseProcessMessage"
    | "markdownResourceLinkSchemes"
  >
> = {
  resolveToolKind: baseToolKindResolver,
  createFunctionResponse: (
    fnCall: FunctionCall,
    confirmed: boolean,
  ): FunctionResponse => ({
    id: fnCall.id,
    name: fnCall.name,
    response: { confirmed },
  }),
  parseProcessMessage: parseAgentMessage,
  markdownResourceLinkSchemes: BASE_MARKDOWN_RESOURCE_LINK_SCHEMES,
};

/** 不绑定企业后端协议的中立预设。 */
export const basePreset: ChatPreset = {
  name: "base",
  strategies: baseChatStrategies,
};
